import { useSelector, useDispatch } from 'react-redux'
import { RootState } from "../../../../setup/redux/RootReducer";
import { useState } from 'react'
import { Product, ProductDetail } from '../models/productServiceModels'
import { GetProductList, GetProductDetail } from '../redux/ProductOperations'
import { setProductList } from '../redux/ProductListSlice'
import { setProductDetail } from '../redux/ProductDetailSlice'
import StoreChange from '../components/StoreChange'
import ProductSearch from '../components/ProductSearch'
import { Button } from 'react-bootstrap-v5'
import CurrentSearch from '../redux/CurrentSearch' 


export default function ProductListPage() {

    const currentStore = useSelector((state: RootState) => state.currentStoreReducer);
    const productListArray = useSelector((state: RootState) => state.productListReducer);
    const dispatch = useDispatch();
    const [detailErrorStr, setDetailErrorStr] = useState("");
    const [previewLoading, setPreviewLoading] = useState(false);


    const getPage=async(page :number)=>{
        setPreviewLoading(true);
        setDetailErrorStr("");
        const searchString=CurrentSearch.GetCurrentSearch();
        if (searchString != "" && searchString != null) {
            let response: any = await GetProductList(currentStore.store.storeNo, searchString, page);
            if (response.data != null) {
                if (response.data.Status != "SUCCESS") {
                    setDetailErrorStr(response.data.Detail);
                    console.log("response.data.Detail");


                } else {
                    dispatch(setProductList(response.data.Detail.productData));
                    dispatch(setProductDetail(new ProductDetail));
                    console.log(response.data.Detail);
                }
            } else {
                setDetailErrorStr("Servis bağlantısı kurulamadı");
            }
        }
        else {
            setDetailErrorStr("Ürün numarası giriniz.");
        }

        setPreviewLoading(false);
    }

    const getDetailImage = async (product: Product) => {
        console.log(product);
        let response: any = await GetProductDetail(currentStore.store.storeNo, product.productId);
        if (response.data != null) {
            if (response.data.Status != "SUCCESS") {

                setDetailErrorStr(response.data.Detail);
            } else {

                dispatch(setProductDetail(response.data.Detail));
                console.log(response.data.Detail);
            }
        } else {
            setDetailErrorStr("Servis bağlantısı kurulamadı");
        }
    }
    function isPrevDisabled() {
        let value = true;
        productListArray.productList.pageCount <= 1 || productListArray.productList.currentPageNumber == 1 ? value = true : value = false;
        return value;
    }
    function isNextDisabled() {
        let value = true;
        productListArray.productList.pageCount <= 1 || productListArray.productList.currentPageNumber == productListArray.productList.pageCount ? value = true : value = false;
        return value;
    }


    return (
        <div className='col-xxl-12' style={{ marginBottom: 15 }}>

            <div className={`card card-xxl-stretch`} style={{ height: 'auto', minHeight: 300, position: 'relative' }}>
                <StoreChange/>
                {/* begin::Header */}
                <div className='card-header align-items-center border-0 mt-4' style={{ display: 'block', overflow: 'scroll', height: 'auto' }}>
               
                <ProductSearch/>
         
                    <div className='card-toolbar'>       
                        {productListArray.productList.results != null && productListArray.productList.results[0] != null &&
                            <table className="table table-row-dashed table-row-gray-300 gy-7">
                                <thead>
                                    <tr className="fw-bolder fs-6 text-gray-800">
                                        <th></th>
                                        <th>Ürün Adı</th>
                                        <th>Stok</th>
                                        <th>Adet</th>
                                        <th>Fiyat</th>
                                        <th>Kampanya Türü</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productListArray.productList.results.map(x =>
                                    
                                        <tr onClick={() => getDetailImage(x)} style={{ cursor: 'pointer' }}>
                                            <td>
                                                <img src={x.productImages.length<=0?"":x.productImages[0].Cdn_url} style={{ maxWidth: 70, maxHeight: 70 }} />
                                            </td>
                                            <td style={{}}><span  >{x.productName} ({x.productId})</span></td>
                                            <td>{x.productStockStatus == 1 ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ color: 'green' }} className="bi bi-check2-circle" viewBox="0 0 16 16">
                                                    <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                    <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                                </svg>
                                                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{ color: 'red' }} className="bi bi-x-circle" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>}</td>
                                            <td>{x.stockQuantity}</td>
                                            <td>₺{x.price.toFixed(2)}</td>
                                            <td>{x.packageType}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        }
                        <div className="col-12" style={{textAlign:'right'}}>
                        <Button variant="outline-primary border" disabled={isPrevDisabled()} size="sm" onClick={() => getPage(productListArray.productList.currentPageNumber-1)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                            </svg></Button>{' '}<Button variant="outline-dark" disabled={true} size="sm">{productListArray.productList.currentPageNumber}/{productListArray.productList.pageCount}</Button>{' '}  
                        <Button variant="outline-primary border"  onClick={() => getPage(productListArray.productList.currentPageNumber+1)} size="sm" disabled={isNextDisabled()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                            </svg></Button>{' '}  
                            </div>
                            </div>


                </div>
            </div>
        </div>
    )
}